import _extends from "@babel/runtime/helpers/extends";
import { Fragment, useCallback } from "react";
import { BannerFooterInlineStyles } from ".";
import { useBanner } from "../../contexts";
import { getOtherOptionsFromWindow, jsxJoin } from "../../utils";
import { useBannerRefToRenderedHeight, usePageIdToPermalinkMapLink } from "../../hooks";
import { BannerFooterLink, BannerTooltip } from ".";

var BannerFooter = function BannerFooter() {
  var banner = useBanner();
  var type = banner.layout.type,
      _banner$legal = banner.legal,
      privacyPolicy = _banner$legal.privacyPolicy,
      privacyPolicyLabel = _banner$legal.privacyPolicyLabel,
      imprint = _banner$legal.imprint,
      imprintLabel = _banner$legal.imprintLabel,
      _banner$footerDesign = banner.footerDesign,
      poweredByLink = _banner$footerDesign.poweredByLink,
      linkTarget = _banner$footerDesign.linkTarget,
      poweredLink = banner.poweredLink,
      activeAction = banner.activeAction,
      isConsentRecord = banner.isConsentRecord,
      onClose = banner.onClose;

  var _getOtherOptionsFromW = getOtherOptionsFromWindow(),
      isPro = _getOtherOptionsFromW.isPro,
      close = _getOtherOptionsFromW.bannerI18n.close,
      affiliate = _getOtherOptionsFromW.affiliate;

  var ref = useBannerRefToRenderedHeight("footerContainer");
  var handleClose = useCallback(function (e) {
    onClose();
    e.preventDefault();
  }, [onClose]);
  var targetAttributes = linkTarget === "_blank" ? {
    target: "_blank",
    rel: "noopener"
  } : {};
  var linkImprint = usePageIdToPermalinkMapLink(imprint);
  var linkPrivacyPolicy = usePageIdToPermalinkMapLink(privacyPolicy);
  var links = jsxJoin([(!!activeAction || isConsentRecord) && h(BannerFooterLink, {
    href: "#",
    onClick: handleClose,
    key: "close"
  }, h("strong", null, close)), !!privacyPolicyLabel && h(BannerFooterLink, _extends({
    href: linkPrivacyPolicy
  }, targetAttributes, {
    key: "privacyPolicy"
  }), privacyPolicyLabel), !!imprintLabel && h(BannerFooterLink, _extends({
    href: linkImprint
  }, targetAttributes, {
    key: "imprint"
  }), imprintLabel)], h(Fragment, null, " \u2022 "));
  return h("div", _extends({
    ref: ref
  }, BannerFooterInlineStyles.footerContainer(banner)), h("div", BannerFooterInlineStyles.footer(banner), links, !!poweredLink && (poweredByLink || !isPro) && h(Fragment, null, type === "dialog" && links !== null && h("br", null), h(BannerFooterLink, {
    href: affiliate ? affiliate.link : poweredLink.href,
    target: poweredLink.target,
    alignRight: type === "banner"
  }, h("span", {
    dangerouslySetInnerHTML: {
      __html: poweredLink.innerHTML
    }
  }), affiliate && h(BannerTooltip, {
    title: affiliate.description
  }, " ", affiliate.labelBehind)), " "), h("div", {
    style: {
      clear: "both"
    }
  })));
};

export { BannerFooter };